import React from 'react'
import { Card } from 'react-bootstrap'

const HomeGoods = () => {
  return (
    <>
		<Card className="text-center rounded-0 no-border home-goods-card container">
				<Card.Body>
					<Card.Title className='home-goods-title'>3Dデジタルアセットの作成</Card.Title>
					<Card.Text className='home-goods-content text-left'>
					あらゆる製品や環境から参照画像や寸法を取得し、リアルな3Dモデル、デジタルツイン、バーチャルワールドを作成します。3Dビジュアルは、高品質なVR/AR/3D体験の基盤となるものです。もし、グラフィックに不満があれば、その体験はすべて台無しになってしまいます。パラコズマは、バーチャル空間を創るとき、ユーザーがそこにいるかのように、ディテールまで見えること、手を伸ばせば触れられるような感覚になることを目指しています。
					</Card.Text>
				</Card.Body>
			</Card>
    </>
  )
}

export default HomeGoods
